export const masonry = {
  'masonry': {
    display: 'grid',
    gridAutoFlow: 'row',
    gap: ['25px', '15px', '15px', '15px'],
  },
  'masonry-section': {
    rowGap: ['25px', '15px', '15px', '15px'],
    columnGap: '35px',
  },
  'masonry-section--1': {
    gridTemplateColumns: ['1fr', '1fr', '1fr', '1fr 1fr 1fr 1fr'],
    gridTemplateRows: ['auto', 'initial'],
  },
  'masonry-section--2': {
    gridTemplateColumns: ['1fr', '1fr 1fr'],
  },
  'masonry-section--3': {
    gridTemplateColumns: ['1fr', '1fr 1fr', '1fr 1fr', '1fr 1fr 1fr'],
    gridTemplateRows: ['auto', 'initial'],
  },
  'masonry-section--4': {
    gridTemplateColumns: ['1fr 1fr', '1fr 1fr', '1fr 1fr', '1fr 1fr 1fr 1fr'],
    gridTemplateRows: ['auto', 'initial'],
  },
  'masonry-section--5': {
    gridTemplateColumns: ['1fr 1fr', '1fr 1fr', '1fr 1fr', '1fr 2.05fr 1fr'],
    gridTemplateRows: 'auto',
  },
  'masonry-section__item': {
    position: 'relative',
    paddingBottom: '85%',
    marginBottom: ['0', 'initial'],
  },
  'masonry__item--3-0': {
    gridColumn: ['auto', '1/3', '1/3', 'auto'],
    gridRow: ['auto', 1, 'auto', 'auto'],
  },
  'masonry__item--3-1': {
    gridColumn: ['auto', 'auto', 1, 'auto'],
    gridRow: ['auto', 'auto', 2, 'auto'],
  },
  'masonry__item--3-2': {
    gridColumn: ['auto', 'auto', 2, 'auto'],
    gridRow: ['auto', 'auto', 2, 'auto'],
  },
  'masonry__item--4-0': {
    gridColumn: ['auto', 'auto', 1, 'auto'],
    gridRow: ['auto', 'auto', 1, 'auto'],
  },
  'masonry__item--4-1': {
    gridColumn: ['auto', 'auto', 2, 'auto'],
    gridRow: ['auto', 'auto', 1, 'auto'],
  },
  'masonry__item--4-2': {
    gridColumn: ['auto', 'auto', 1, 'auto'],
    gridRow: ['auto', 'auto', 2, 'auto'],
  },
  'masonry__item--4-3': {
    gridColumn: ['auto', 'auto', 2, 'auto'],
    gridRow: ['auto', 'auto', 2, 'auto'],
  },
  'masonry__item--5-0': {
    gridColumn: [1, 'auto', '1/3', 2],
    gridRow: [1, 'auto', 'auto', '1/3'],
  },
  'masonry__item--5-1': {
    gridColumn: ['auto', 'auto', 'auto', 1],
    gridRow: ['auto', 'auto', 'auto', 1],
  },
  'masonry__item--5-2': {
    gridColumn: ['auto', 'auto', 'auto', 1],
    gridRow: ['auto', 'auto', 'auto', 2],
  },
  'masonry__item--5-3': {
    gridColumn: ['auto', 'auto', 'auto', 3],
    gridRow: ['auto', 'auto', 'auto', 2],
  },
  'masonry__item--5-4': {
    gridColumn: ['auto', '1/3', 'auto', 3],
    gridRow: ['auto', 'auto', 'auto', 1],
  }
};
